<template>
  <b-modal
    v-model="show"
    hide-backdrop
    static
    id="clear-list"
    size="sm"
    hide-header
    footer-class="border-top m-auto w-100 reset-footer"
    body-class="p-2"
    @ok="onOk"
    @cancel="onCancel"
    :ok-title="hebrew ? 'מחק' : 'Delete'"
    :cancel-title="hebrew ? 'אל תמחק' : 'Cancel'"
  >
    <div class="text-center">
      {{hebrew ? 'האם אתה בטוח שברצונך' : 'Are you sure you want to'}}
      <br>
      {{hebrew ? 'למחוק את הרשימה' : 'delete current text'}}?
      <div class="custom-control custom-checkbox">
        <input type="checkbox" id="checkboxAsk" class="custom-control-input" v-model="checked" @change="preventResetDialog">
        <label for="checkboxAsk" class="custom-control-label">
          <small>{{hebrew ? 'אל תציג שוב' : 'Don\'t show again'}}</small>
        </label>
      </div>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: "ResetDialog",
  props: ["value"],
  data() {
    return {
      checked: false
    }
  },  
  computed: {
    hebrew () {
      return this.$settings.hebrew
    },    
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    preventResetDialog () {
      localStorage.setItem("NOT_ASK", this.checked)
    },
    onCancel () {
      this.$emit("dialogClick", {clicked:false, dontShowAgain: this.checked})
    },
    onOk () {
      this.$emit("dialogClick", {clicked:true, dontShowAgain: this.checked})
    }
  }
};
</script>
<style lang="scss">
  #clear-list{
    &.modal{
      position: relative;
      top: -190px;
      width: 245px;
      left: 100px;
      .modal-dialog {
        margin: 10px;
        height: 200px;
        
      }
    }
  }
  .reset-footer{
    padding: 0.5rem;
    position: relative;
    button{
      width:50%;
      padding: 3px 0;
    }
    &::before, &::after {
      left: 50%;
      bottom: -14px;
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid;  
    }
    &::after {  
      margin-left: -9px;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 10px solid;
      border-top-color: #fff;
      bottom: -13px;
    }
    &::before {  
      margin-left: -10px;
      border-left: 11px solid transparent;
      border-right: 11px solid transparent;
      border-top: 11px solid;
      border-top-color: rgba(0,0,0,.25);
    }          
  }
</style>